import Insight from "../insightClass";
import React from "react";
import { insight24Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight050 = new Insight(
  "13 June 2025",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight24Media[0],
    alt: "offshore wind turbine",
  },
  "Global Offshore Wind Weekly (2025-06-13)",
  "",
  `TenneT successfully installed the DolWin Epsilon high-voltage direct current (HVDC) platform in the German North Sea, enhancing grid capacity for offshore wind integration and strengthening renewables infrastructure.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2025-06-13)</h1>
    <h2></h2>
    <p className="article-date">13 June 2025</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>

    <h3>1. UK: German DolWin Epsilon HVDC platform installed in North Sea</h3>
    <p>
      TenneT successfully installed the DolWin Epsilon high-voltage direct
      current (HVDC) platform in the German North Sea, enhancing grid capacity
      for offshore wind integration and strengthening renewables
      infrastructure.  
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      This milestone not only fortifies German offshore grid resilience but also
      signals progress toward a meshed European network. HVDC hubs like
      DolWin Epsilon will be essential for cross-border energy trading and
      accommodating more intermittent renewables efficiently.
    </p>
    <h3>
      2. Scottish Port Secures EUR 29 Million Investment for Floating Wind
      Upgrade
    </h3>
    <p>
      Ardersier Port in the Scottish Highlands has secured €29 million from the
      UK Infrastructure Bank and Scottish National Investment Bank to develop
      infrastructure that will support floating offshore wind manufacturing and
      deployment. The investment will help transform the site into a key hub for
      floating wind projects in the North Sea.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      his investment is strategically timed as Scotland prepares to deliver the
      ScotWind and INTOG lease rounds. Port infrastructure remains one of the
      most significant bottlenecks to scaling floating wind—both in turbine
      assembly and substructure deployment. 
    </p>
    <h3>3. France Launches First Floating Offshore Wind Farm</h3>
    <p>
      France has officially launched its first floating offshore wind farm, the
      30 MW Provence Grand Large project off the coast of
      Port-Saint-Louis-du-Rhône. The project includes three 10 MW Siemens Gamesa
      turbines mounted on tension-leg floating platforms developed by SBM
      Offshore and IFP Energies nouvelles.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      This marks a crucial milestone for France, which has lagged in offshore
      wind deployment despite an extensive coastline and favourable wind
      resources. The use of tension-leg platforms is particularly
      notable—offering a stable and scalable solution for deep-water sites. The
      project will offer vital performance data to derisk future floating
      developments under France’s 50 GW offshore target by 2050.
    </p>
    <h3>4. Brazil: Petrobras issues geophysical tenders off Rio de Janeiro</h3>
    <p>
      State-owned Petrobras launched two geophysical tenders (bathymetry,
      tomography, geotechnical) for a pilot offshore wind site near São João
      da Barra—marking its initial foray into renewables. 
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Petrobras leveraging its seismic expertise is a smart strategy—enabling
      low-cost market entry in offshore wind. Early geotech studies are
      foundational; success could trigger Brazil’s offshore zoning map and
      unlock South America’s deep-sea potential.
    </p>
    <h3>5. US: Maryland issues final air-quality permit to US Wind</h3>
    <p>
      Maryland has granted the final state air-quality permit to US Wind’s
      offshore wind project, clearing the way for construction—though legal and
      political challenges remain. 
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      This helps US Wind inch toward FID, mitigating years-long permitting
      bottlenecks. However, pending lawsuits and political backlash may delay
      build-out. WeBridge advocates for blended federal-state coordination to
      de-risk permitting for future US projects.
    </p>
    <h3>6. US: Atlantic Shores petitions to terminate OREC Order</h3>
    <p>
      Atlantic Shores Offshore Wind Project 1 (New Jersey/New York) sought
      termination of its Offshore Renewable Energy Certificate order, citing
      revoked air permits, federal inertia, and ongoing regulatory ambiguity. 
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Abandonment of OREC support highlights how permitting gridlock can derail
      site economics. Short-term, this pressures state regulators; long-term, it
      signals that robust federal-level engagement is needed to secure financing
      for remaining US Atlantic sites.
    </p>
    <h3>7. China: Underwater data centre powered by offshore wind launched</h3>
    <p>
      Shanghai launched the world’s first commercial underwater data centre
      (UDC) fully powered by offshore wind—integrating renewables and digital
      infrastructure in a marine innovation hub. 
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      This pioneering coupling of renewables and data tech highlights offshore
      wind’s role beyond power generation. As demand for low-carbon digital
      infrastructure grows, co-locating UDCs near wind farms could optimize
      cable capacity and O&M synergies.
    </p>

    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
